import React from "react";

export default ({children}: any) => (<>{children}</>)